import React from "react"
import RehypeReact from "rehype-react"
import { remark } from "remark"
import { toHast } from "mdast-util-to-hast"

import {
  Anchor,
  AppButton,
  Choice,
  Choose,
  CTA,
  // BlogCards,
  Centered,
  Dark,
  Download,
  GuideCategories,
  Grid,
  H1,
  H2,
  H3,
  H4,
  H5,
  H6,
  Header,
  Hero,
  HeroImage,
  BuieDemo,
  Highlight,
  ImageFrame,
  Banner,
  BannerTitle,
  HorizontalList,
  LoggedIn,
  LoginButton,
  Message,
  Next,
  More,
  Observe,
  Observer,
  Pre,
  Postman,
  ReferenceCategories,
  ResetButton,
  Samples,
  Store,
  Trigger,
  Table,
  YouTube,
  FeaturedBoard,
  Tile,
  TileGrid,
  TileSlider,
  Teaser,
  AgentConfiguration,
} from "~components/Markdown"

import { Tabs, Tab } from "~components/Tabs"

const components = {
  a: Anchor,
  appbutton: AppButton,
  banner: Banner,
  bannertitle: BannerTitle,
  // blogcards: BlogCards,
  centered: Centered,
  choice: Choice,
  choose: Choose,
  cta: CTA,
  dark: Dark,
  download: Download,
  grid: Grid,
  guidecategories: GuideCategories,
  h: Highlight,
  h1: H1,
  h2: H2,
  h3: H3,
  h4: H4,
  h5: H5,
  h6: H6,
  header: Header,
  hero: Hero,
  horizontallist: HorizontalList,
  imageframe: ImageFrame,
  loggedin: LoggedIn,
  loginbutton: LoginButton,
  message: Message,
  more: More,
  next: Next,
  observe: Observe,
  observer: Observer,
  postman: Postman,
  pre: Pre,
  referencecategories: ReferenceCategories,
  resetbutton: ResetButton,
  samples: Samples,
  store: Store,
  tab: Tab,
  table: Table,
  tabs: Tabs,
  trigger: Trigger,
  youtube: YouTube,
  featuredboard: FeaturedBoard,
  tile: Tile,
  tilegrid: TileGrid,
  tileslider: TileSlider,
  teaser: Teaser,
  heroimage: HeroImage,
  buiedemo: BuieDemo,
  agentconfiguration: AgentConfiguration,
}

export const recognizedCompontents = components

export const render = (ast) => {
  const rehype = new RehypeReact({
    createElement: React.createElement,
    components,
  }).Compiler

  return rehype(ast)
}
export const plainRender = (ast) => {
  const rehype = new RehypeReact({
    createElement: React.createElement,
  }).Compiler

  return rehype(ast)
}

export const githubRender = (ast) => {
  const rehype = new RehypeReact({
    createElement: React.createElement,
    components: {
      pre: Pre,
      a: Anchor,
      tab: Tab,
      tabs: Tabs,
    },
  }).Compiler

  return rehype(ast)
}

export const astify = (value) => toHast(remark().parse(value))
